import {getEventTitle} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getTitleMargin, isTitleVisible} from '../../../selectors/single-settings'
import sc from '../../classes.scss'
import {LinkToPage} from '../../link-to-page'
import {TitleProps} from './interfaces'
import s from './title.scss'

export const Title = ({event, onImage}: TitleProps) => {
  const titleVisible = useWidgetState(isTitleVisible)
  const marginBottom = useWidgetState(getTitleMargin)

  return titleVisible ? (
    <div style={{marginBottom}}>
      <div
        className={classNames(s.root, sc.textNoMargin, sc.preWrap, {
          [s.onImage]: onImage,
        })}
        data-hook={DH.eventTitle}
      >
        <LinkToPage event={event} allowExternal>
          {getEventTitle(event)}
        </LinkToPage>
      </div>
    </div>
  ) : null
}
